import React, { useContext, useState, useRef, useEffect } from 'react'
import { Formik, Form, Field, useFormikContext } from 'formik';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { LeadsContext } from '../Context/LeadsContext';
import { getImages } from '../Const';
import EditVehicleOptions from './EditVehicleOptions';
import EditTitleStatus from './EditTitleStatus';
import CustomAutoSearch from '../Common/CustomAutoSearch';

const BeginAppraisalTab = ({ appraisalData, close, setShowEtitleBox, setEditingAppraisal, appraisalStage }) => {

    const { updateLeadDataMultiple, vehicleListSearch, decodeVIN, validateVIN, defaultYears } = useContext(LeadsContext);

    const [vehicleYears, setVehicleYears] = useState([appraisalData?.year || ""]);
    const [vehicleMakes, setVehicleMakes] = useState([appraisalData?.make || ""]);
    const [vehicleModels, setVehicleModels] = useState([appraisalData?.model || ""]);
    const [vehicleTrims, setVehicleTrims] = useState([appraisalData?.trim || ""]);

    const [autoSearchReset,setAutoSearchReset] = useState(0);

    var colorList = [
        { id: 1, title: "White" },
        { id: 2, title: "Black" },
        { id: 3, title: "Gray" },
        { id: 4, title: "Silver" },
        { id: 5, title: "Red" },
        { id: 6, title: "Blue" },
        { id: 7, title: "Green" },
        { id: 8, title: "Brown" },
        { id: 9, title: "Orange" },
        { id: 10, title: "Other" }
    ];

    if(appraisalData.color && !(appraisalData.color in colorList.map(obj => obj.title))) colorList.push({id: 11, title: appraisalData.color});

    const [vehicleYearData, setVehicleYearData] = useState([]);

    const formikRef = useRef();

    useEffect(() => {

        setVehicleYears(defaultYears);

        if(appraisalData.year) getVehicleYearData(appraisalData.year);
    }, [defaultYears]);

    const getVehicleYearData = async (year) => {
        if(String(year).length != 4) return;
        const data = await vehicleListSearch({ 'subject': 'yeardata', 'year': year });
        //console.log(data);

        setVehicleYearData(data);

        let makes = [];

        if ('makes' in data) {
            data['makes'].map((make, i) => {
                makes.push(make.name);
            });

            if(appraisalData.make) {
                if(!(appraisalData.make in makes)) makes.push(appraisalData.make);
                formikRef.current.setFieldValue("make",appraisalData.make);
            }

            setVehicleMakes(makes);
        }
    }

    const getVehicleModels = async (make) => {
        //console.log(year, make);

        if ('makes' in vehicleYearData) {

            let models = [];

            vehicleYearData['makes'].filter((item) => item.name == make).map((make, i) => {
                //console.log(make);
                if ('models' in make) {
                    make['models'].map((model, j) => {
                        models.push(model.name);
                    })
                }
            });

            if(appraisalData.model) {
                if(!(appraisalData.model in models)) models.push(appraisalData.model);
                formikRef.current.setFieldValue("model",appraisalData.model);
            }

            setVehicleModels(models);
        }
    }

    const getVehicleTrims = async (model) => {
        //console.log(year, make, model);
        const make = formikRef.current.values.make;

        if ('makes' in vehicleYearData) {

            let trims = [];

            vehicleYearData['makes'].filter((item) => item.name == make).map((make, i) => {
                //console.log(make);
                if ('models' in make) {
                    make['models'].filter((item) => item.name == model).map((model, j) => {
                        if ('trims' in model) {
                            model['trims'].map((trim, k) => {
                                trims.push(trim.name);
                            })
                        }
                    })
                }
            });

            if(appraisalData.trim) {
                if(!(appraisalData.trim in trims)) trims.push(appraisalData.trim);
                formikRef.current.setFieldValue("trim",appraisalData.trim);
            }

            setVehicleTrims(trims);
        }
    }

    const doDecodeVIN = async (vin, setFieldValue) => {

        if (vin && validateVIN(vin)) {
            var decode_data = await decodeVIN(vin);

            console.log(decode_data);

            if (decode_data.year) {
                setVehicleYears([decode_data.year]);
                setFieldValue("year", decode_data.year);
            }

            if (decode_data.make) {
                setVehicleMakes([decode_data.make]);
                setFieldValue("make", decode_data.make);
            }

            if (decode_data.model) {
                setVehicleModels([decode_data.model]);
                setFieldValue("model", decode_data.model);
            }

            if (decode_data.trims && decode_data.trims.length > 0) {
                setVehicleTrims([decode_data.trims[0].name]);
                setFieldValue("trim", decode_data.trims[0].name);
            }


        } else
            alert("Please enter a valid VIN");
    }
    const [selectedOptions, setSelectedOptions] = useState(appraisalData?.vehicle_options || []);

    const updateNote = () => {
        var note = "";
        
        if(formikRef.current.values.titlestatus) note += formikRef.current.values.titlestatus + ". ";

        if(selectedOptions.length > 0) note += "Options: " + selectedOptions.join(', ');

        formikRef.current.setFieldValue("appraisal_note",note);
    }

    useEffect(() => {
        updateNote();
    },[selectedOptions]);

    return (
        <Formik
            initialValues={{
                id: appraisalData?.id || "",
                first_name: appraisalData?.first_name || "",
                last_name: appraisalData?.last_name || "",
                phone: appraisalData?.phone || "",
                email: appraisalData?.email || "",
                address: appraisalData?.address || "",
                state: appraisalData?.state || "",
                city: appraisalData?.city || "",
                zip_code: appraisalData?.zip_code || "",
                year: appraisalData?.year || "",
                make: appraisalData?.make || "",
                model: appraisalData?.model || "",
                trim: appraisalData?.trim || "",
                location: appraisalData?.location || "",
                vin: appraisalData?.vin || "",
                mileage: appraisalData?.mileage || "",
                vehicle_condition: appraisalData?.vehicle_condition || "",
                vehicle_details: appraisalData?.vehicle_details || "",
                appraisal_date: appraisalData?.appraisal_date || new Date(),
                expiration_date: appraisalData?.expiration_date || new Date(Date.now() + 7 * 24 * 60 * 60 * 1000),
                appraisal: appraisalData?.appraisal || "",
                status: appraisalData?.status || (appraisalStage && appraisalStage == "NewLead" ? "" : "Available"),
                appraisal_note: appraisalData?.notes?.filter((note) => note.title == "Appraisal Details").reduce((acc, note_obj) => { return acc + " " + note_obj.note }, ""),
                appraisal_complete: appraisalData?.appraisal_stage == "Completed",
                appraisal_stage: appraisalData?.appraisal_stage,

                // New Keys
                vehicle_keys: appraisalData?.vehicle_keys || "",
                books: appraisalData?.books || "",
                color: appraisalData?.color || "",
                vehicle_condition: appraisalData?.vehicle_condition || "",
                titlestatus: appraisalData?.titlestatus || "",
                lender: appraisalData?.lender || "",
            }}
            innerRef={formikRef}
            onSubmit={(values, {resetForm}) => {
                var finalValues = {
                    ...values,
                    vehicle_options: selectedOptions,
                };
                if (values.appraisal_complete && values.status == "Available") {
                    appraisalData.appraisal_stage = "Callback";
                    values.appraisal_stage = "Callback";
                }

                const newStage = (appraisalStage && appraisalStage == "NewLead") ? appraisalData.appraisal_stage : (values.appraisal_complete || values.appraisal_stage == "Completed" ? "Completed" : "InProgress");
                const newType = (appraisalStage && appraisalStage == "NewLead") ? appraisalData.lead_type : 'InPerson'

                finalValues.appraisal_stage = newStage;
                finalValues.lead_type = newType;

                if(appraisalStage && appraisalStage == "NewLead") {
                    delete finalValues.appraisal_date;
                    delete finalValues.expiration_date;
                }

                finalValues = Object.fromEntries(
                    Object.entries(finalValues).filter(([_, value]) => value)
                );

                updateLeadDataMultiple(finalValues);
                appraisalData.appraisal_stage = newStage;
                appraisalData.lead_type = newType;
                if(appraisalStage && appraisalStage == "NewLead") close();
                setEditingAppraisal(false);
                console.log('Form Submitted finalValues:', finalValues);

                setVehicleYears(defaultYears);   
                setAutoSearchReset((prev) => prev + 1);
                resetForm();
            }}
        >
            {({ values, setFieldValue }) => (
                <Form className='begin-form'>
                    {/* {console.log("appraisalData?.titlestatus", appraisalData?.titlestatus)} */}
                    <Field type="hidden" name="id" value={values.id} />
                    <Field type="hidden" name="appraisal_stage" value={values.appraisal_stage} />
                    <div className="accordion autopilot-accordion ad-accordion">
                        <div className="accordion-item">
                            <h2 className="accordion-header">
                                <button className="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
                                    Customer Info
                                </button>
                            </h2>
                            <div id="collapseOne" className="accordion-collapse collapse show">
                                <div className="accordion-body px-0">
                                    <div className='row'>
                                        <div className='col-md-6'>
                                            <div className='mb-4'>
                                                <div className='adr-label mb-1'>First Name</div>
                                                <Field name="first_name" type="text" className='form-control' />
                                            </div>
                                            {appraisalData.last_name &&
                                                <div className='mb-4'>
                                                    <div className='adr-label mb-1'>Last Name</div>
                                                    <Field name="last_name" type="text" className='form-control' />
                                                </div>
                                            }
                                            <div className='mb-4'>
                                                <div className='adr-label mb-1'>Phone</div>
                                                <Field name="phone" type="text" className='form-control' />
                                            </div>
                                            <div className='mb-4'>
                                                <div className='adr-label mb-1'>Email</div>
                                                <Field name="email" type="text" className='form-control' />
                                            </div>
                                        </div>
                                        <div className='col-md-6'>
                                            <div className='mb-4'>
                                                <div className='adr-label mb-1'>Address</div>
                                                <Field name="address" type="text" className='form-control' />
                                            </div>
                                            <div className='mb-4'>
                                                <div className='adr-label mb-1'>State</div>
                                                <Field name="state" as="select" className='form-control'>
                                                    <option value="">-Select-</option>
                                                    <option value="AL">Alabama</option>
                                                    <option value="AK">Alaska</option>
                                                    <option value="AZ">Arizona</option>
                                                    <option value="AR">Arkansas</option>
                                                    <option value="CA">California</option>
                                                    <option value="CO">Colorado</option>
                                                    <option value="CT">Connecticut</option>
                                                    <option value="DE">Delaware</option>
                                                    <option value="DC">District Of Columbia</option>
                                                    <option value="FL">Florida</option>
                                                    <option value="GA">Georgia</option>
                                                    <option value="HI">Hawaii</option>
                                                    <option value="ID">Idaho</option>
                                                    <option value="IL">Illinois</option>
                                                    <option value="IN">Indiana</option>
                                                    <option value="IA">Iowa</option>
                                                    <option value="KS">Kansas</option>
                                                    <option value="KY">Kentucky</option>
                                                    <option value="LA">Louisiana</option>
                                                    <option value="ME">Maine</option>
                                                    <option value="MD">Maryland</option>
                                                    <option value="MA">Massachusetts</option>
                                                    <option value="MI">Michigan</option>
                                                    <option value="MN">Minnesota</option>
                                                    <option value="MS">Mississippi</option>
                                                    <option value="MO">Missouri</option>
                                                    <option value="MT">Montana</option>
                                                    <option value="NE">Nebraska</option>
                                                    <option value="NV">Nevada</option>
                                                    <option value="NH">New Hampshire</option>
                                                    <option value="NJ">New Jersey</option>
                                                    <option value="NM">New Mexico</option>
                                                    <option value="NY">New York</option>
                                                    <option value="NC">North Carolina</option>
                                                    <option value="ND">North Dakota</option>
                                                    <option value="OH">Ohio</option>
                                                    <option value="OK">Oklahoma</option>
                                                    <option value="OR">Oregon</option>
                                                    <option value="PA">Pennsylvania</option>
                                                    <option value="RI">Rhode Island</option>
                                                    <option value="SC">South Carolina</option>
                                                    <option value="SD">South Dakota</option>
                                                    <option value="TN">Tennessee</option>
                                                    <option value="TX">Texas</option>
                                                    <option value="UT">Utah</option>
                                                    <option value="VT">Vermont</option>
                                                    <option value="VA">Virginia</option>
                                                    <option value="WA">Washington</option>
                                                    <option value="WV">West Virginia</option>
                                                    <option value="WI">Wisconsin</option>
                                                    <option value="WY">Wyoming</option>
                                                </Field>
                                            </div>
                                            <div className='mb-4'>
                                                <div className='adr-label mb-1'>City</div>
                                                <Field name="city" type="text" className='form-control' />
                                            </div>
                                            <div className='mb-4'>
                                                <div className='adr-label mb-1'>Zip Code</div>
                                                <Field name="zip_code" type="text" className='form-control' />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="accordion-item">
                            <h2 className="accordion-header">
                                <button className="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target="#collapseTwo" aria-expanded="true" aria-controls="collapseTwo">
                                    Vehicle Details
                                </button>
                            </h2>
                            <div id="collapseTwo" className="accordion-collapse collapse show">
                                <div className="accordion-body px-0">
                                    <div className='row'>
                                        <div className='col-md-6'>
                                            <div className='mb-4'>
                                                <div className='adr-label mb-1'>Vehicle Year</div>
                                                <Field name="year" type="hidden" /> 
                                                <CustomAutoSearch 
                                                    filteredList={vehicleYears.map((v,i) => {return {"id":i,"title":v.toString()}})} 
                                                    fieldName={"year"} 
                                                    setFieldValue={setFieldValue} 
                                                    initialValue={values.year}
                                                    doOnChange={getVehicleYearData}
                                                    resetValue={autoSearchReset}
                                                />
                                                {/*appraisalData.year ? 
                                                <Field
                                                    name="year"
                                                    className='form-control'
                                                    onChange={(e) => { setFieldValue('year', e.target.value); getVehicleYearData(e.target.value); }}
                                                />
                                                :
                                                <Field
                                                    name="year"
                                                    as="select"
                                                    className='form-control'
                                                    onChange={(e) => { setFieldValue('year', e.target.value); getVehicleYearData(e.target.value); }}
                                                >
                                                    <option value=''>
                                                        Select
                                                    </option>
                                                    {vehicleYears.map((v, i) => (
                                                        <option key={i} value={v}>
                                                            {v}
                                                        </option>
                                                    ))}
                                                </Field>*/}
                                            </div>
                                        </div>
                                        <div className='col-md-6'>
                                            <div className='mb-4'>
                                                <div className='adr-label mb-1'>VIN</div>
                                                <Field name="vin" type="text" className='form-control' onChange={(e) => {
                                                    setFieldValue("vin", e.target.value);
                                                    if (validateVIN(e.target.value))
                                                        doDecodeVIN(e.target.value, setFieldValue);
                                                }} />
                                            </div>
                                        </div>
                                        <div className='col-md-6'>
                                            <div className='mb-4'>
                                                <div className='adr-label mb-1'>Vehicle Make</div>
                                                <Field name="make" type="hidden" />
                                                <CustomAutoSearch 
                                                    filteredList={vehicleMakes.map((v,i) => {return {"id":i,"title":v.toString()}})} 
                                                    fieldName={"make"} 
                                                    setFieldValue={setFieldValue} 
                                                    initialValue={values.make}
                                                    doOnChange={getVehicleModels}
                                                    resetValue={autoSearchReset}
                                                />
                                                {/*appraisalData.make ? 
                                                <Field
                                                    name="make"
                                                    className='form-control'
                                                    onChange={(e) => { setFieldValue('make', e.target.value); getVehicleModels(e.target.value); }}
                                                />
                                                :
                                                <Field
                                                    as="select"
                                                    name="make"
                                                    className="form-control"
                                                    onChange={(e) => { setFieldValue('make', e.target.value); getVehicleModels(e.target.value); }}
                                                >
                                                    <option value=''>
                                                        Select
                                                    </option>
                                                    {vehicleMakes.map((v, i) => (
                                                        <option key={i} value={v}>
                                                            {v}
                                                        </option>
                                                    ))}
                                                </Field>*/}
                                            </div>
                                        </div>
                                        <div className='col-md-6'>
                                            <div className='mb-4'>
                                                <div className='adr-label mb-1'>Mileage</div>
                                                <Field name="mileage" type="text" className='form-control' />
                                            </div>
                                        </div>
                                        <div className='col-md-6'>
                                            <div className='mb-4'>
                                                <div className='adr-label mb-1'>Vehicle Model</div>
                                                <Field name="model" type="hidden" />
                                                <CustomAutoSearch 
                                                    filteredList={vehicleModels.map((v,i) => {return {"id":i,"title":v.toString()}})} 
                                                    fieldName={"model"} 
                                                    setFieldValue={setFieldValue} 
                                                    initialValue={values.model}
                                                    doOnChange={getVehicleTrims}
                                                    resetValue={autoSearchReset}
                                                />
                                                {/*appraisalData.model ? 
                                                <Field
                                                    name="model"
                                                    className='form-control'
                                                    onChange={(e) => { setFieldValue('model', e.target.value); getVehicleTrims(e.target.value); }}
                                                />
                                                :
                                                <Field
                                                    as="select"
                                                    name="model"
                                                    className="form-control"
                                                    onChange={(e) => { setFieldValue('model', e.target.value); getVehicleTrims(e.target.value); }}
                                                >
                                                    <option value=''>
                                                        Select
                                                    </option>
                                                    {vehicleModels.map((v, i) => (
                                                        <option key={i} value={v}>
                                                            {v}
                                                        </option>
                                                    ))}
                                                </Field>*/}
                                            </div>
                                        </div>
                                        <div className='col-md-6'>
                                            <div className='mb-4'>
                                                <div className='adr-label mb-1'>Location</div>
                                                <Field name="location" as="select" className='form-control' value={values.location} onChange={(e) => { setFieldValue('location', e.target.value); }}>
                                                    <option value="BOYNTON BEACH">BOYNTON BEACH</option>
                                                    <option value="POMPANO BEACH">POMPANO BEACH</option>
                                                </Field>
                                            </div>
                                        </div>
                                        <div className='col-md-6'>
                                            <div className='mb-4'>
                                                <div className='adr-label mb-1'>Vehicle Trim</div>
                                                <Field name="trim" type="hidden" />
                                                <CustomAutoSearch 
                                                    filteredList={vehicleTrims.map((v,i) => {return {"id":i,"title":v.toString()}})} 
                                                    fieldName={"trim"} 
                                                    setFieldValue={setFieldValue} 
                                                    initialValue={values.trim}
                                                    resetValue={autoSearchReset}
                                                />
                                                {/*appraisalData.trim ? 
                                                <Field
                                                    name="trim"
                                                    className='form-control'
                                                    onChange={(e) => { setFieldValue('trim', e.target.value); }}
                                                />
                                                :
                                                <Field
                                                    as="select"
                                                    name="trim"
                                                    className="form-control"
                                                    onChange={(e) => { setFieldValue('trim', e.target.value); }}
                                                >
                                                    <option value=''>
                                                        Select
                                                    </option>
                                                    {vehicleTrims.map((v, i) => (
                                                        <option key={i} value={v}>
                                                            {v}
                                                        </option>
                                                    ))}
                                                </Field>*/}
                                            </div>
                                        </div>
                                        <div className='col-md-6'>
                                            {/* <div className='mb-4'>
                                                <div className='adr-label mb-1'>Vehicle Condition</div>
                                                <Field name="vehicle_condition" type="text" className='form-control' />
                                            </div> */}
                                        </div>
                                        <div className='col-md-6'>
                                            <div className='mb-4'>
                                                <div className='adr-label mb-1'>Color</div>
                                                {/*<Field name="color" type="text" className='form-control' />*/}
                                                <Field name="color" type="hidden">
                                                </Field> 
                                                <CustomAutoSearch filteredList={colorList} fieldName={"color"} setFieldValue={setFieldValue} initialValue={values.color} resetValue={autoSearchReset}/>
                                            </div>
                                        </div>
                                        <div className='col-md-6'>
                                            <div className='row'>
                                                <div className='col-md-6 mb-4'>
                                                    <div className='adr-label mb-1'>Keys</div>
                                                    <Field name="vehicle_keys" as="select" className='form-control'>
                                                        <option value="yes">Yes</option>
                                                        <option value="no">No</option>
                                                        <option value="1">1</option>
                                                        <option value="2">2</option>
                                                        <option value="3">3</option>
                                                    </Field>
                                                </div>
                                                <div className='col-md-6 mb-4'>
                                                    <div className='adr-label mb-1'>Books</div>
                                                    <Field name="books" as="select" className='form-control'>
                                                        <option value="no">No</option>
                                                        <option value="yes">Yes</option>
                                                    </Field>
                                                </div>
                                            </div>
                                        </div>
                                        {/* Title Status Fields Indside This */}
                                        <EditTitleStatus values={values} setShowEtitleBox={setShowEtitleBox} setFieldValue={setFieldValue} selectedOptions={selectedOptions} updateNote={updateNote}/>
                                        {/* Tag Fields Indside This */}
                                        <EditVehicleOptions
                                            selectedOptions={selectedOptions}
                                            setSelectedOptions={setSelectedOptions}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="accordion-item">
                            <h2 className="accordion-header">
                                <button className="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target="#collapseThree" aria-expanded="true" aria-controls="collapseThree">
                                    Appraisal Details
                                </button>
                            </h2>
                            <div id="collapseThree" className="accordion-collapse collapse show">
                                <div className="accordion-body px-0">
                                    <div className='row'>
                                        <div className='col-md-6'>
                                            <div className='mb-4'>
                                                <div className='adr-label mb-1'>Appraisal Date</div>
                                                {/* <DatePicker
                                                    selected={values.appraisal_date ? new Date(values.appraisal_date) : new Date()}
                                                    // onChange={(date) => setFieldValue('appraisal_date', date)}
                                                    className='form-control'
                                                    dateFormat="MM-dd-yyyy"
                                                /> */}
                                                <DatePicker
                                                    selected={values.appraisal_date ? new Date(values.appraisal_date) : new Date()}
                                                    readOnly
                                                    disabled
                                                    className="form-control"
                                                    dateFormat="MM-dd-yyyy"
                                                    onChange={(date) => setFieldValue('appraisal_date', date)}
                                                />
                                            </div>
                                            <div className='mb-4'>
                                                <div className='adr-label mb-1'>Appraisal Expiration Date</div>
                                                <DatePicker
                                                    selected={values.expiration_date ? new Date(values.expiration_date) : new Date(Date.now() + 7 * 24 * 60 * 60 * 1000)}
                                                    // // onChange={(date) => setFieldValue('expiration_date', date)}
                                                    // className='form-control'
                                                    // dateFormat="MM-dd-yyyy"
                                                    readOnly
                                                    disabled
                                                    className="form-control"
                                                    dateFormat="MM-dd-yyyy"
                                                    onChange={(date) => setFieldValue('expiration_date', date)}
                                                />
                                            </div>
                                        </div>
                                        <div className='col-md-6'>
                                            <div className='mb-4'>
                                                <div className='adr-label mb-1'>Appraisal Value</div>
                                                <Field name="appraisal" type="text" className='form-control' />
                                            </div>
                                            <div className='mb-4'>
                                                <div className='adr-label mb-1'>Status</div>
                                                <Field name="status" as="select" className='form-control' value={values.status}>
                                                    <option>Select</option>
                                                    <option value="Rejected">Rejected</option>
                                                    <option value="Bought">Bought</option>
                                                    <option value="Traded In">Traded In</option>
                                                    <option value="Sold to Carmax">Sold to Carmax</option>
                                                    <option value="Sold Elsewhere">Sold Elsewhere</option>
                                                    <option value="Not Selling">Not Selling</option>
                                                    <option value="Available">Available</option>
                                                </Field>
                                            </div>
                                        </div>
                                        <div className='col-12'>
                                            <div className='mb-4'>
                                                <div className='adr-label mb-1'>Vehicle Condition</div>
                                                <Field name="vehicle_condition" as="textarea" className='form-control h-64' />
                                            </div>
                                        </div>
                                        <div className='col-12'>
                                            <div className='mb-4'>
                                                <div className='adr-label mb-1'>Appraisal Details</div>
                                                <Field name="appraisal_note" as="textarea" className='form-control' />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className='mt-4 text-end'>
                        <div className="custom-checkbox begin-checkbox me-5">
                            <Field
                                type="checkbox"
                                name="appraisal_complete"
                                id="AppraisalComplete"
                                checked={values.appraisal_complete}
                            />
                            <label htmlFor="AppraisalComplete">Appraisal Complete</label>
                        </div>
                        <button type='submit' className='blue-btn md-btn text-center text-uppercase'>Save</button>
                    </div>
                </Form>
            )}
        </Formik>
    )
}

export default BeginAppraisalTab